import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    mainContainer: {
        maxWidth: '1176px',
        margin: '0 auto',
        fontFamily: ["Open Sans", "sans-serif"],
        boxSizing: 'border-box',
    },
    printContainer: {
        '@media print': {
            fontFamily: ["Open Sans", 'sans-serif'],
            lineHeight: '1.15',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontVariant: 'normal',
            fontSize: '16px',
            color: '#2d4691',
            margin: '0 auto',
            boxSizing: 'border-box',
        }
    }
});

export default styles;
